module.exports = __webpack_public_path__ + "static/media/Wire1.f349c4b3.glb";